export default __webpack_public_path__ + "static/media/logo_cnda2.34846838.png";